import { Extensions, JSONContent } from '@tiptap/core';
import { generateHTML } from '@tiptap/html';

export const tiptapJsonToHtml = ({
  extensions,
  json,
}: {
  extensions: Extensions;
  json: JSONContent;
}): string => {
  return generateHTML(json, extensions);
};
